import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ServerConn } from '../serverConn.service';
import { IAPIResponse } from '../_interfaces/api-response.interface';

export interface IBugsReportsDataItem {
  id: number;
  name: string;
}

export interface IBugsReportsData {
  classifications: IBugsReportsDataItem[];
  severities: IBugsReportsDataItem[];
  states: IBugsReportsDataItem[];
}

export interface IBugReport {
  subject: string;
  description: string;
  platform: string;
  browser: string;
  classification: number;
  severity?: number;
  state?: number;
  url?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BugsReportsServiceService {

  private unsubscribe = new Subject<void>();

  public classifications: IBugsReportsDataItem[];
  public severities: IBugsReportsDataItem[];
  public states: IBugsReportsDataItem[];

  constructor(
    private server: ServerConn,
  ) {
    this.getData();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getData() {
    this.server.get(
      'bugs/aux-data'
    )
    .pipe(
      takeUntil(this.unsubscribe)
    )
    .subscribe((response: any) => {
      if (response.result) {
        this.classifications = response.data.classifications;
        this.severities = response.data.severities;
        this.states = response.data.states;
      }
    });
  }

  send(data: IBugReport): Observable<IAPIResponse> {
    return <Observable<IAPIResponse>>this.server.post(
      'bugs/send',
      {
        d: JSON.stringify(data)
      }
    )
    .pipe(
      takeUntil(this.unsubscribe)
    );
  }

}
